import { Component, Input, Output, EventEmitter } from '@angular/core';
import { FormField } from '../../entities/form.entity';

@Component({
  selector: 'app-field-multiple-choice',
  templateUrl: './field-multiple-choice.component.html',
  styleUrls: ['./field-multiple-choice.component.scss'],
})
export class FieldMultipleChoiceComponent {
  @Input() field!: FormField;
  @Input() disabled: boolean = false;
  @Output() onFieldChange = new EventEmitter<{
    fieldId: string;
    isValid: boolean;
    value: any[];
  }>();

  handleMultipleChoiceChange(option: string, event: Event): void {
    const isChecked = (event.target as HTMLInputElement).checked;
    if (!this.field.value) {
      this.field.value = [];
    }

    const newValue = [...this.field.value];

    if (isChecked && !newValue.includes(option)) {
      newValue.push(option);
    } else if (!isChecked && newValue.includes(option)) {
      const index = newValue.indexOf(option);
      newValue.splice(index, 1);
    }

    this.field.value = newValue;
    this.emitFieldChange();
  }

  emitFieldChange(): void {
    this.onFieldChange.emit({
      fieldId: this.field.fieldId,
      isValid: this.validateField(),
      value: this.field.value,
    });
  }

  validateField(): boolean {
    if (!Array.isArray(this.field.value)) {
      return false;
    }

    if (this.field.isRequired && this.field.value.length === 0) {
      return false;
    }

    if (this.field.metadata?.allOptionsRequired) {
      return this.field.options.every((option) =>
        this.field.value.includes(option)
      );
    }

    return true;
  }
}
